import Vue, { VNode } from 'vue'

import App from './App.vue'
import '@/assets/tailwind.css'

Vue.config.productionTip = false
Vue.config.devtools = true

// eslint-disable-next-line import/prefer-default-export
export const app = new Vue({
  render: (h): VNode => h(App),
}).$mount('#app')
